import {
  CREATE_VOCABULARY_NEW_RECORD,
  CREATE_VOCABULARY_NEW_RECORD_SUCCESS,
  CREATE_VOCABULARY_NEW_RECORD_ERROR,

  GET_VOCABULARY_NEW_RECORD,
  GET_VOCABULARY_NEW_RECORD_SUCCESS,
  GET_VOCABULARY_NEW_RECORD_ERROR,

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,
} from "../actions";

export const getVocabularyNewRecord = (vocabularyId, history, activityInfo) => ({
  type: GET_VOCABULARY_NEW_RECORD,
  payload: { vocabularyId, history, activityInfo }
});

export const getVocabularyNewRecordSuccess = (recordCreated) => ({
  type: GET_VOCABULARY_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const getVocabularyNewRecordError = (message) => ({
  type: GET_VOCABULARY_NEW_RECORD_ERROR,
  payload: { message },
});

export const createVocabularyNewRecord = (newRecord, history, activityInfo) => ({
  type: CREATE_VOCABULARY_NEW_RECORD,
  payload: { newRecord, history, activityInfo }
});

export const createVocabularyNewRecordSuccess = (recordCreated) => ({
  type: CREATE_VOCABULARY_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createVocabularyNewRecordError = (message) => ({
  type: CREATE_VOCABULARY_NEW_RECORD_ERROR,
  payload: { message },
});

export const hideNewRecordPanel = () => ({
  type: PANEL_NEW_RECORD_HIDE_CLICK,
  payload: {},
});

export const toggleNewRecordPanel = () => ({
  type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  payload: {},
});

export const setRecordType = (recordTypeSelected) => ({
  type: SET_RECORD_TYPE,
  payload: { recordTypeSelected },
});

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});